import { useEffect, useState } from "react";
import { cx } from "@/utils/cx";

type WorkspaceLogoProps = {
  name: string;
  logoUrl?: string | null;
  /** Pass Tailwind size + shape classes, e.g. "size-8 rounded-md" */
  className?: string;
};

export const WorkspaceLogo = ({ name, logoUrl, className }: WorkspaceLogoProps) => {
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    setImgError(false);
  }, [logoUrl]);

  if (logoUrl && !imgError) {
    return (
      <img
        src={logoUrl}
        alt={`${name} logo`}
        className={cx("object-contain flex-shrink-0", className)}
        onError={() => setImgError(true)}
      />
    );
  }

  return (
    <div className={cx("bg-secondary flex items-center justify-center shrink-0 ring-1 ring-primary", className)}>
      <span className="text-[9px] font-bold text-tertiary">{name.substring(0, 3).toUpperCase()}</span>
    </div>
  );
};
